import { makeAutoObservable } from 'mobx';
import { z } from 'zod';
import extractValue, {
  type EventOrValue,
} from '../../../../store/utils/extractValue';
import Validator, {
  type ValidatorErrors,
} from '../../../../store/utils/Validator';

export default class ResetPassword {
  static Schema = z.object({
    email: z.email(),
  });

  email = '';

  private validator = new Validator(this, ResetPassword.Schema);

  constructor(private readonly onReset: (email: string) => Promise<void>) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  get errors(): ValidatorErrors<PasswordResetDto> {
    return this.validator.errorsForEnabledFields;
  }

  get isValid(): boolean {
    return this.validator.isValid;
  }

  get allErrorsAsStrings(): string[] {
    return this.validator.allErrorsAsStrings;
  }

  handleChange(e: EventOrValue<keyof PasswordResetDto>) {
    const { name, value } = extractValue(e);
    Object.assign(this, { [name]: value });
    this.validator.validate();
    this.validator.enableFieldValidation(name);
  }

  handleBlur(e: EventOrValue<keyof PasswordResetDto>) {
    const { name } = extractValue(e);
    this.validator.enableFieldValidation(name);
  }

  async reset() {
    await this.onReset(this.email);
  }
}

export interface PasswordResetDto {
  email: string;
}
